import { type GrapeAPIErrorType } from 'components/hooks/GrapeAPIError'
import { Banner } from 'slab'

import { OnboardingGenericErrorMessage } from './OnboardingGenericErrorMessage'

export const PageErrorBanner = ({ error }: { error: GrapeAPIErrorType }) => {
  if (error.status === 409) {
    return (
      <Banner
        title='Onboarding has been completed.'
        type='info'
      >
        <p>Taking you to the next step...</p>
      </Banner>
    )
  }

  return (
    <Banner
      title='A problem has occurred while processing your request'
      type='critical'
    >
      <OnboardingGenericErrorMessage
        error={error}
      />
    </Banner>
  )
}
